import { IconType } from "react-icons/lib";
import { TbCancel, TbQrcode, TbQrcodeOff } from "react-icons/tb";

import { UserExtras, UserType } from "@/types/user.types";

import { softColors } from "./colors";

export type UserLoginStatusListItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    cond: (userType: UserType, extras: UserExtras) => boolean;
};

export type UserLoginStatusList = UserLoginStatusListItem[];

export const shiftTypeStatuses: UserLoginStatusList = [
    {
        label: "Araçsız Mesai",
        component: () => TbQrcodeOff,
        ...softColors.blue,
        tooltip: {
            title: "Araçsız Mesai",
            description: "Kullanıcı araçsız mesai işlemlerini yapabilir.",
        },
        cond: (userType, extras) => !!(userType === UserType.DRIVER && extras & UserExtras.SHIFT_WITHOUT_VEHICLE),
    },
    {
        label: "Araçlı Mesai",
        component: () => TbQrcode,
        ...softColors.green,
        tooltip: {
            title: "Araçlı Mesai",
            description: "Kullanıcı araçsız mesai işlemlerini yapamaz.Araç zorunludur.",
        },
        cond: (userType, extras) => userType === UserType.DRIVER && !(extras & UserExtras.SHIFT_WITHOUT_VEHICLE),
    },
    {
        label: "Mesai tipi seçilemez",
        component: () => TbCancel,
        ...softColors.brown,
        tooltip: {
            title: "Kullanıcı  mesai tipi",
            description: "Kullanıcı  mesai işlemlerinde araçtan bağımsızdır.",
        },
        cond: (userType) => userType != UserType.DRIVER,
    },
];
